import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'success' | 'error' | 'info';
  hasDescription: boolean;
}

const toastTypeVariations = {
  info: css`
    background: var(--toast-default-bg);
    color: var(--toast-default-cl);
  `,
  success: css`
    background: #e6fffa;
    color: var(--success-hover);
  `,
  error: css`
    background: var(--red-50);
    color: var(--red-500);
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 360px;
  position: relative;
  padding: 1rem 2rem 1rem 1rem;
  border-radius: 0.75rem;
  box-shadow: 2px 2px 0.5rem rgba(0, 0, 0, 0.2);
  display: flex;

  & + div {
    margin-top: 0.5rem;
  }

  ${(props) => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 0.2rem 0.75rem 0 0;
  }

  ${(props) =>
    !props.hasDescription &&
    css`
      align-items: center;
      svg {
        margin-top: 0;
      }
    `}
`;

export const MessageContainer = styled.div`
  flex: 1;
`;

export const Message = styled.strong``;

export const Paragraph = styled.p`
  margin-top: 0.5rem;
  font-size: 1rem;
  opacity: 0.8;
  line-height: 1.5rem;
`;

export const Button = styled.button`
  position: absolute;
  right: 1rem;
  top: 1.15rem;
  opacity: 0.6;
  border: 0;
  background: transparent;
  color: inherit;
`;
